export let PaymentMethodTypes = /*#__PURE__*/function (PaymentMethodTypes) {
  PaymentMethodTypes["BankAccount"] = "bankAccount";
  PaymentMethodTypes["PlaidBankAccount"] = "plaidBankAccount";
  PaymentMethodTypes["CreditCard"] = "creditCard";
  return PaymentMethodTypes;
}({});
export let BankAccountStatusTypes = /*#__PURE__*/function (BankAccountStatusTypes) {
  BankAccountStatusTypes["New"] = "new";
  BankAccountStatusTypes["Validated"] = "validated";
  BankAccountStatusTypes["Verified"] = "verified";
  BankAccountStatusTypes["VerificationFailed"] = "verification_failed";
  BankAccountStatusTypes["TwoAttemptsFailed"] = "twoAttemptsFailed";
  BankAccountStatusTypes["PlaidVerification"] = "plaidVerification";
  BankAccountStatusTypes["PlaidVerificationFailed"] = "plaidVerificationFailed";
  BankAccountStatusTypes["FailedDueToDuplicate"] = "failed_due_to_duplicate";
  BankAccountStatusTypes["Errored"] = "errored";
  return BankAccountStatusTypes;
}({});
export let PlaidBankAccountStatusTypes = /*#__PURE__*/function (PlaidBankAccountStatusTypes) {
  PlaidBankAccountStatusTypes["PendingAutomaticVerification"] = "pending_automatic_verification";
  PlaidBankAccountStatusTypes["PendingManualVerification"] = "pending_manual_verification";
  PlaidBankAccountStatusTypes["AutomaticallyVerified"] = "automatically_verified";
  PlaidBankAccountStatusTypes["ManuallyVerified"] = "manually_verified";
  PlaidBankAccountStatusTypes["VerificationExpired"] = "verification_expired";
  PlaidBankAccountStatusTypes["VerificationFailed"] = "verification_failed";
  return PlaidBankAccountStatusTypes;
}({});
export let VerifyWithEnum = /*#__PURE__*/function (VerifyWithEnum) {
  VerifyWithEnum["Plaid"] = "plaid";
  VerifyWithEnum["Stripe"] = "stripe";
  VerifyWithEnum["None"] = "none";
  return VerifyWithEnum;
}({});